export default __webpack_public_path__ + "static/media/8.3a58c49b.webp";